import { render, staticRenderFns } from "./SlotsMain.vue?vue&type=template&id=15cc6b3e&scoped=true"
import script from "./SlotsMain.vue?vue&type=script&lang=js"
export * from "./SlotsMain.vue?vue&type=script&lang=js"
import style0 from "./SlotsMain.vue?vue&type=style&index=0&id=15cc6b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cc6b3e",
  null
  
)

export default component.exports